import { atom } from 'jotai'

export const verificacionDatosPersonales = atom([]);
export const tabNumberAtom = atom();
export const colaboradorPendienteAtom = atom([]);
export const loadingAtom= atom(false);